import { theme } from '../../theme/theme'
import { IconProps } from './types'

const DEFAULT_SIZE = 30
const DEFAULT_COLOR = theme.color.plum

export const Lines = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR }: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="4" y1="8" x2="18" y2="8" stroke={color} strokeWidth="4" strokeLinecap="round" />
      <line x1="4" y1="17" x2="27" y2="17" stroke={color} strokeWidth="4" strokeLinecap="round" />
      <line x1="4" y1="26" x2="22" y2="26" stroke={color} strokeWidth="4" strokeLinecap="round" />
    </svg>
  )
}
